import { render, staticRenderFns } from "./DialogError.vue?vue&type=template&id=16d051d0&"
import script from "./DialogError.vue?vue&type=script&lang=js&"
export * from "./DialogError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports